import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { FIELD_PRIMITIVE__base } from '../../_primitives/_base/FIELD_PRIMITIVE__base';
import { FIELD__list_image_asset } from '../../_primitives/list/FIELD__list_image_asset';
import { FIELD__list_token } from '../../_primitives/list/FIELD__list_token';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { FIELD__image_asset } from '../../image/FIELD__image_asset';
import { FIELD__base } from '../FIELD__base';

export enum ENUM__field_group_type {
  IMAGES = 'images',
  MODELS = 'models',
  PRIMITIVES = 'primitives',
  TOKENS = 'tokens',
}

export type FieldClass<T extends FIELD__base = FIELD__base> = new (...args: any[]) => T;

export namespace ENUM_UTILS__field_group_type {
  export function filter_fields_by_group<T extends FIELD__base>(fields: FIELD__base[], type: ENUM__field_group_type): FieldClass<T>[] {
    let out: FieldClass<T>[] = [];

    let types = [];

    switch (type) {
      case ENUM__field_group_type.IMAGES:
        types = [FIELD__list_image_asset, FIELD__image_asset];
        break;
      case ENUM__field_group_type.MODELS:
        types = [FIELD_PRIMITIVE__string_hash_ml_asset];
        break;
      case ENUM__field_group_type.PRIMITIVES:
        types = [FIELD_PRIMITIVE__base];
        break;
      case ENUM__field_group_type.TOKENS:
        types = [FIELD__list_token];
        break;
      default:
        not_implemented_type(type);
    }

    return out;
  }
}
